import { defineComponent, h, ref, useAttrs } from 'vue'
import { VForm } from 'vuetify/components'

VForm.compatConfig = {
  ...(VForm.compatConfig || {}),
  COMPONENT_V_MODEL: false,
  INSTANCE_ATTRS_CLASS_STYLE: false
}

function normalizeModelValue(attrs) {
  return attrs.modelValue ?? attrs.value
}

function stripLegacyAttrs(attrs) {
  const normalized = { ...attrs }
  delete normalized.value
  return normalized
}

export default defineComponent({
  name: 'VFormCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,
  emits: ['update:modelValue', 'input', 'submit'],

  setup(_, { emit, expose, slots }) {
    const attrs = useAttrs()
    const formRef = ref(null)

    expose({
      validate: (...args) => formRef.value?.validate?.(...args),
      reset: (...args) => formRef.value?.reset?.(...args),
      resetValidation: (...args) => formRef.value?.resetValidation?.(...args)
    })

    return () =>
      h(
        VForm,
        {
          ...stripLegacyAttrs(attrs),
          ref: formRef,
          modelValue: normalizeModelValue(attrs),
          'onUpdate:modelValue': (value) => {
            emit('update:modelValue', value)
            emit('input', value)
          },
          onSubmit: (event) => emit('submit', event)
        },
        slots
      )
  }
})
